<template>
  <div v-show="show" class="empty-page">
    <div class="data-null" :class="{'no-result': isNoResult, 'no-bind': isNoBind}">
      <p class="tips">{{tips}}</p>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "empty-page",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
      default: '还没有数据哦～',
    },
    isNoResult: Boolean,
    isNoBind: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.empty-page {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    background-color: var(--g2);
    .data-null {
      position: absolute;
      top: 50%;
      width: 100%;
      margin: auto;
      padding-top: calc(var(--gap) * 128);
      text-align: center;
      transform: translateY(-50%);
      background: transparent url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png) top center/128px 128px no-repeat;
      .tips {
        font-size: var(--fs-md);
        color: var(--g6);
      }
      .van-button--primary{
        padding: 0 calc(var(--gap) * 45);
      }
      &.no-result{
        background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/no-result.png);
      }
      &.no-bind{
        background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/no-bind.png);
      }
    }
  }
</style>
